import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BasicModal } from 'components/BasicModal';
import Button from 'components/Button';
import Tooltipped from 'components/Tooltipped';
import { SlightEmphasisIconNote } from 'components/Typography';
import { shouldShowTipCreator, seenTooltips } from 'redux/selectors';
import { dismissTooltip, tempDismissTip } from 'redux/actions';
import * as _ from 'lib/utilities';

let InitialTipPopup = ({ tipName, shouldShowTip, dismiss, tempDismiss, title, children, id, btn1Label, btn2Label, btn1Action, btn2Action, btn1Primary, btn2Primary, alwaysDismissForever }) => {
    const { t } = useTranslation();

    if(!shouldShowTip) {
        return '';
    }

    return (
        <BasicModal
            startOpen
            fullWidth
            className="limit-width"
            options={{ dismissible: false, endingTop: '10vh' }}
            triggerRender={() => ''}
            contentRender={() => {
                return (
                    <React.Fragment>
                        <div className="center info-color pt15 pb15" id={id}>
                            <div style={{ fontSize: '100px', lineHeight: 1}}>
                                <FontAwesomeIcon icon="info-circle" />
                            </div>
                        </div>
                        <div className="text-center limit-50-h">
                            <h1>{title || t('Heads Up!')}</h1>
                            {children}
                            <div className="pa20">
                                <Button
                                    color="primary"
                                    noShadow
                                    outlined={!btn1Primary}
                                    rounded
                                    className="modal-close"
                                    onClick={() => {
                                        setTimeout(() => {
                                            dismiss(tipName);
                                            btn1Action && btn1Action();
                                        },350);
                                    }}
                                >
                                    {btn1Label || t("Don't Show Again")}
                                </Button>
                                <Button
                                    color="primary"
                                    noShadow
                                    rounded
                                    outlined={!btn2Primary}
                                    className="modal-close ml5"
                                    onClick={() => {
                                        setTimeout(() => {
                                            alwaysDismissForever ? dismiss(tipName) : tempDismiss(tipName);
                                            btn2Action && btn2Action();
                                        },350);
                                    }}
                                >
                                    {btn2Label || t("Got It")}
                                </Button>
                            </div>
                        </div>

                    </React.Fragment>
                )
            }}
        />
    )
}

const mapStateToPopupProps = (state,{ tipName }) => ({
    shouldShowTip: shouldShowTipCreator(tipName)(state)
})

const mapDispatchToPopupProps = dispatch => ({
    dismiss: tipName => dispatch(dismissTooltip(tipName)),
    tempDismiss: tipName => dispatch(tempDismissTip(tipName))
})

InitialTipPopup = connect(mapStateToPopupProps,mapDispatchToPopupProps)(InitialTipPopup);

let SlightEmphasisTip = ({ dismiss, tipName, seenTooltips, ...props }) => {
    const [seen, setSeen] = useState(seenTooltips && seenTooltips.includes(tipName));
    const newDismiss = () => {
        setSeen(true);
        dismiss(tipName);
    }

    if(seen) {
        return '';
    } else {
        return (
            <SlightEmphasisIconNote
                dismiss={newDismiss}
                {...props}
            />
        )
    }
}

const mapStateToTipProps = state => ({
    seenTooltips: seenTooltips(state)
})

const mapDispatchToTipProps = dispatch => ({
    dismiss: (tipName) => dispatch(dismissTooltip(tipName))
})

SlightEmphasisTip = connect(mapStateToTipProps,mapDispatchToTipProps)(SlightEmphasisTip);


let InitialTip = ({ tipName, onlyAfter, text, delay, dismiss, seenTooltips, children, onClick, noMouseOver, options, passThroughProps, ...tipProps }) => {
    const seen = seenTooltips && seenTooltips.includes(tipName);
    const prevNeeded = _.difference(onlyAfter || [],seenTooltips || []).length > 0;
    const [hide, setHide] = useState(false);
    const doDismiss = () => {
        setHide(true);
        if(!seen)
            dismiss(tipName);
    }
    const clickHandler = () => {
        onClick && onClick();
        doDismiss();
    }

    return (
        <Tooltipped
            dismissCallback={doDismiss}
            autoShowAfter={delay}
            options={{
                html: text,
                classes: ['square'],
                ...options
            }}
            onClick={clickHandler}
            onMouseOver={noMouseOver ? null : doDismiss}
            disableTip={seen || hide || prevNeeded}
            passThroughProps={passThroughProps}
            {...tipProps}
        >
            {children}
        </Tooltipped>
    )
}

InitialTip = connect(mapStateToTipProps,mapDispatchToTipProps)(InitialTip)

export { InitialTipPopup, SlightEmphasisTip, InitialTip };
